import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgPromoCode = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.405 24h-.703a2.74 2.74 0 0 1-1.248-.73L.8 15.615c-.398-.398-.664-.793-.8-1.318v-.703c.125-.489.349-.883.723-1.257l11.27-11.252c.545-.545 1.305-.72 2.044-.536l6.34 1.568c.136.033.253.084.383.126L22.77.232c.283-.283.69-.314.989-.054.256.225.351.692.069.976l-2.074 2.084c.036.112.086.224.116.344L23.455 10a2.1 2.1 0 0 1-.543 2.004l-11.226 11.25c-.381.383-.78.622-1.28.746Zm11.683-13.677L20.62 4.379 18.927 6.06c.441.962.139 2.072-.717 2.656-.84.573-1.977.46-2.69-.264a2.11 2.11 0 0 1-.219-2.694 2.115 2.115 0 0 1 2.636-.688l1.683-1.694-5.928-1.464c-.274-.067-.522-.014-.727.191L1.605 13.45a.696.696 0 0 0 .006.983l7.957 7.958c.286.286.727.265 1.007-.015l11.319-11.34c.195-.196.255-.425.195-.712Zm-5.26-4.019a.696.696 0 0 0-.47.89.71.71 0 0 0 .834.46.697.697 0 0 0 .504-.865.69.69 0 0 0-.869-.485Z"
      />
      <path
        fill="currentColor"
        d="M6.265 14.713c-.44.053-.757-.224-.816-.634-.052-.363.175-.8.575-.848l8.875-1.066c.415-.05.742.27.779.672s-.222.775-.634.825zm4.408.041a2.073 2.073 0 0 1 2.416 1.683 2.09 2.09 0 0 1-1.68 2.41A2.073 2.073 0 0 1 9 17.206a2.073 2.073 0 0 1 1.673-2.453Zm.233 1.37a.69.69 0 1 0 .268 1.351.69.69 0 0 0-.268-1.351m-.999-8.116a2.07 2.07 0 0 1 2.246 1.899c.092 1.112-.76 2.148-1.895 2.245a2.084 2.084 0 0 1-2.247-1.85 2.073 2.073 0 0 1 1.896-2.294m-.045 1.418a.684.684 0 0 0-.429.895.69.69 0 0 0 1.313-.426.683.683 0 0 0-.884-.47Z"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgPromoCode);
export default Memo;
